<owc-header #headerElement>
    <owc-header-row class="cn-edit-flow-top-bar" style="gap: 10px;">
      <owc-icon (click)="cancelNotificationProcess()" name="circle_clear" family="" style="cursor: pointer;"></owc-icon>
      <span>Create local notification </span>
      <span>{{localNotificationId}}</span>
    </owc-header-row>
</owc-header>
  
<owc-modal-dialog [(ngModel)]="isCancelDialogOpen" size="small">
  <owc-component-header slot="header">Cancel notification</owc-component-header>
  <div>
    <owc-typography variant="body2">
      You have started creating a local notification. To keep the progress, choose the "Save Changes" button. To close without saving, choose the "Discard" button.
    </owc-typography>
  </div>
  <owc-component-footer slot="footer" style="gap: 10px;">
    <owc-button (click)="discard()">Discard</owc-button>
    <owc-button (click)="saveChanges()">Save Changes</owc-button>
  </owc-component-footer>
</owc-modal-dialog>
  